<template>
  <div>
    <navigation></navigation>
    <div class="container px-4 mx-auto">
      <book-nav-public></book-nav-public>

      <h2 class="note-title">
        <span v-if="note">{{ note.title }}</span>
        <span v-else>Note</span>
      </h2>
      <div class="page" v-if="note">
        <div
          class="content bg-white pt-3 px-4 pb-4 border"
          v-html="note.content"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from "../env.js";
import Navigation from "./Navigation.vue";
import PublicSearchDropdown from "./PublicSearchDropdown";
import BookNavPublic from "./BookNavPublic";
export default {
  data() {
    return {};
  },
  created() {
    this.getPage();
  },
  computed: {
    note() {
      const slug = this.$route.params.note;
      const index = this.$store.state.notes.notes.findIndex(
        x => x.slug === slug
      );
      return this.$store.state.notes.notes[index];
    },
    book() {
      return this.$store.state.notes.book;
    },
    author() {
      return this.$store.state.notes.author;
    }
  },
  components: {
    Navigation,
    PublicSearchDropdown,
    BookNavPublic
  },
  props: [],
  methods: {
    getPage() {
      const user = this.$route.params.user;
      const book = this.$route.params.book;
      const note = this.$route.params.note;
      let uri = `${API_URL}/u/${user}/${book}/${note}`;
      this.$store.dispatch("NOTES_USER_NOTE", uri);
    }
  }
};
</script>

<style lang="scss">
.content pre {
  overflow-y: scroll;
}
// .message-content.false {
//     max-height: 200px;
//     overflow-y: scroll;
// }
</style>
